import React, { Children } from 'react';
import { observer } from 'src/utils/mobx-react';
import { LoadingIcon } from 'src/ui/assets/icons/other/LoadingIcon';
import { ButtonBox } from 'src/ui/components/button/common/Button.style';
import { ButtonPropsType } from 'src/ui/components/button/common/types';

export const Button = observer(
    'Button',
    ({
        appearance,
        children,
        className,
        dataTest,
        isDisabled,
        isLoading = false,
        onClick,
        size,
        type = 'button',
    }: ButtonPropsType): JSX.Element => {
        const hasChildren = Children.count(children) > 0;

        return (
            <ButtonBox
                appearance={appearance}
                className={className}
                data-test={dataTest}
                disabled={isDisabled}
                isLoading={isLoading}
                onClick={onClick}
                size={size}
                type={type}
            >
                {isLoading ? <LoadingIcon /> : null}
                {hasChildren ? children : null}
            </ButtonBox>
        );
    }
);
